/* eslint jsx-a11y/anchor-is-valid: 0 */

import React, {useState, useEffect, useRef} from "react";
import {
  Container,
  Row,
  Card,
  CardBody,
  FormCheckbox,
  FormSelect,
  ListGroup,
  ListGroupItem,
  Col,
  Form,
  FormFeedback,
  Button,
  FormInput,
  FormTextarea,
} from "shards-react";
import {useParams} from "react-router-dom";
import { getUserLocale } from 'get-user-locale';
import GooglePlacesAutocomplete, {geocodeByPlaceId, getLatLng} from 'react-google-places-autocomplete';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HomeIcon from '@mui/icons-material/Home';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import PrintIcon from '@mui/icons-material/Print';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { faCheck, faEllipsisH, faMessa, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PageTitle from "../../components/common/PageTitle";
import { accessCheck } from "../../utils/tools";
import { generateUrl } from "../../utils/square";
import { loadConnectAndInitialize } from "@stripe/connect-js";
import { ConnectComponentsProvider, ConnectAccountOnboarding } from "@stripe/react-connect-js";
import { STRIPE_PUBLISHABLE_KEY } from "../../environmentVariables";

const language = (getUserLocale() && getUserLocale().length === 5) ? getUserLocale() : 'en_US';
const locale = language.substr(-2).toLowerCase();

const EditLocation = (props) => {
  let {locationId} = useParams();
  const [location, setLocation] = useState(props.locations.find(location => location.id === locationId));
  const [client, setClient] = useState(props.user.type === 'super' ? null : props.clients[0].id);
  const [active, setActive] = useState(true);
  const [name, setName] = useState('');
  const [locations, setLocations] = useState(props.locations);
  const [addedLocation, setAddedLocation] = useState(false);
  const [validName, setValidName] = useState(null);
  const [address1, setAddress1] = useState(null);
  const [address2, setAddress2] = useState(null);
  const [city, setCity] = useState(null);
  const [state, setState] = useState(null);
  const [zip, setZip] = useState(null);
  const [lat, setLat] = useState(null);
  const [lon, setLon] = useState(null);
  const [earlyBirdDays, setEarlyBirdDays] = useState(14)
  const [earlyBirdPercentage, setEarlyBirdPercentage] = useState(25)
  const [earlyBirdFixedAmount, setEarlyBirdFixedAmount] = useState(0)
  const [penaltyDays, setPenaltyDays] = useState(45)
  const [penaltyPercentage, setPenaltyPercentage] = useState(25)
  const [penaltyFixedAmount, setPenaltyFixedAmount] = useState(0)
  const [writeOffDays, setWriteOffDays] = useState(200)
  const [configurationStage, setConfigurationStage] = useState(1)
  const [violations, setViolations] = useState([{name: null, amount: null, code: null, newItem: true}])
  const [officerAlertMessage, setOfficerAlertMessage] = useState('This vehicle is a frequent violator')
  const [violationRules, setViolationRules] = useState({citation_rule: {citations: 3, months: 3}})
  const [footerText, setFooterText] = useState('')
  const [citationTerm, setCitationTerm] = useState('Parking Violation')
  const [warningTerm, setWarningTerm] = useState('Violation Warning')
  const [firstParagraph, setFirstParagraph] = useState('')
  const [parklyncApiKey, setParklyncApiKey] = useState(null)
  const [parklyncLocationId, setParklyncLocationId] = useState(null)
  const [spotheroLocationId, setSpotheroLocationId] = useState(null)
  const [t2LocationId, setT2LocationId] = useState(null)
  const [parkpliantUsername, setParkpliantUsername] = useState(null)
  const [parkpliantPassword, setParkpliantPassword] = useState(null)
  const [parkpliantIanaTimezone, setParkpliantIanaTimezone] = useState(null)
  const [parkpliantSendDays, setParkpliantSendDays] = useState(90)
  const [parkpliantServiceFee, setParkpliantServiceFee] = useState(5.00)
  const [parkMobileUsername, setParkMobileUsername] = useState(null)
  const [parkMobilePassword, setParkMobilePassword] = useState(null)
  const [parkMobileApiKey, setParkMobileApiKey] = useState(null)
  const [parkMobileLocationId, setParkMobileLocationId] = useState(null)
  const [parkWhizLocationId, setParkWhizLocationId] = useState(null)
  const [parisCustomerCode, setParisCustomerCode] = useState(null)
  const [parisUserId, setParisUserId] = useState(null)
  const [parisUserPassword, setParisUserPassword] = useState(null)
  const [parisFacId, setParisFacId] = useState(null)
  const [parisLocations, setParisLocations] = useState(null)
  const [parisLocationsLoading, setParisLocationsLoading] = useState(false)
  const [parisLocationsError, setParisLocationsError] = useState(null)
  const [parkchirpEmail, setParkchirpEmail] = useState(null)
  const [parkchirpPassword, setParkchirpPassword] = useState(null)
  const [parkchirpFacilityId, setParkchirpFacilityId] = useState(null)
  const [parkchirpStaging, setParkchirpStaging] = useState(false)
  const [tezparkLocationId, setTezparkLocationId] = useState(null)
  const [justparkPassesLotIds, setJustparkPassesLotIds] = useState('')
  const [parkchirpFacilities, setParkchirpFacilities] = useState(null)
  const [parkchirpFacilitiesLoading, setParkchirpFacilitiesLoading] = useState(false)
  const [parkchirpFacilitiesError, setParkchirpFacilitiesError] = useState(null)
  const [squareLocations, setSquareLocations] = useState(null)
  const [squareLocationSelected, setSquareLocationSelected] = useState(null)
  const [squareToken, setSquareToken] = useState(null)
  const [paymentProcessor, setPaymentProcessor] = useState('square')
  const [stripeAccountId, setStripeAccountId] = useState(null)
  const [stripeAccountStatus, setStripeAccountStatus] = useState('not_connected')
  const [stripeCurrentlyDue, setStripeCurrentlyDue] = useState([])
  const [stripeConnectInstance, setStripeConnectInstance] = useState(null)
  const [showStripeOnboarding, setShowStripeOnboarding] = useState(false)
  const [stripeConnecting, setStripeConnecting] = useState(false)
  const [stripeConnectError, setStripeConnectError] = useState(null)
  const [stripeStatusChecking, setStripeStatusChecking] = useState(false)
  const [stripeSetupMode, setStripeSetupMode] = useState('create')
  const [stripeLinkAccountId, setStripeLinkAccountId] = useState('')
  const [stripeLinking, setStripeLinking] = useState(false)
  const params = (new URL(document.location)).searchParams;
  const returnTo = params.get('return-to')
  const addressSelector = useRef(null);
  const [subtitle, setSubtitle] = useState('Step 1')
  const [hidePhotos, setHidePhotos] = useState(false)
  const [showPayDisputeMessage, setShowPayDisputeMessage] = useState(true)
  const [hideAmountsOnZPL, setHideAmountsOnZPL] = useState(false)
  const [ignoreWhitelist, setIgnoreWhitelist] = useState(false)
  const [requireDisputeAddress, setRequireDisputeAddress] = useState(false)
  const [validAddress1, setValidAddress1] = useState(true);
  const [validCity, setValidCity] = useState(true);
  const [validState, setValidState] = useState(true);
  const [validZip, setValidZip] = useState(true);
  const [earlyBirdFixedAmountToggle, setEarlyBirdFixedAmountToggle] = useState(false);
  const [penaltyFixedAmountToggle, setPenaltyFixedAmountToggle] = useState(false);

  useEffect(() => {
    props.getLiveLocations(props.user.id)
    !accessCheck(props.user, 'locations') && (window.location.href = '/') 
    
    // Check for URL parameter to set the active stage
    const params = new URLSearchParams(window.location.search);
    const stageParam = params.get('stage');
    if (stageParam && !isNaN(parseInt(stageParam))) {
      setConfigurationStage(parseInt(stageParam));
    }
  }, [])

  useEffect(() => {
    if (location) {
      setName(location.name || '')
      setAddress1(location.address1 || '')
      setAddress2(location.address2 || '')
      setCity(location.city || '')
      setState(location.state || '')
      setZip(location.zip || '')
      setLat(location.lat || '')
      setLon(location.lon || '')
      setClient(location.client || null)
      setActive(!!location.active)
      setEarlyBirdDays(location.early_bird?.offer_days || 0)
      setEarlyBirdPercentage(location.early_bird?.percentage || 0)
      setEarlyBirdFixedAmount(location.early_bird?.fixed_amount || 0)
      setPenaltyDays(location.penalty?.days || 0)
      setPenaltyPercentage(location.penalty?.percentage || 0)
      setPenaltyFixedAmount(location.penalty?.fixed_amount || 0)
      setWriteOffDays(typeof location.write_off_days === 'number' ? location.write_off_days : 200)
      
      // Make sure each violation has the is_archived property set
      let locationViolations = location.violation_fees || [{name: null, amount: null, code: null, newItem: true}];
      locationViolations = locationViolations.map(violation => ({
        ...violation,
        is_archived: violation.is_archived || false
      }));
      setViolations(locationViolations)
      
      setOfficerAlertMessage(location.officer_alert_message || 'This vehicle is a frequent violator')
      setViolationRules(location.violation_rules || {citation_rule: {citations: 3, months: 3}})
      setFooterText(location.footer_text || '')
      setCitationTerm(location.citation_term || 'Parking Violation')
      setWarningTerm(location.warning_term || 'Violation Warning')
      setFirstParagraph(location.first_paragraph || 'Your vehicle was found to be in violation of the terms of parking at ' + location.name + ', ' + location.address1 + ', ' + location.city + ', ' + location.state + ' ' + location.zip)
      setParklyncApiKey(location.parklync_api_key || null)
      setParklyncLocationId(location.parklync_location_id || null)
      setSpotheroLocationId(location.spothero_location_id || null)
      setT2LocationId(location.t2_location_id || null)
      setParkpliantUsername(location.parkpliant_username || null)
      setParkpliantPassword(location.parkpliant_password || null)
      setParkpliantIanaTimezone(location.iana_timezone || null)
      setParkpliantSendDays(location.parkpliant_days || 90)
      setParkpliantServiceFee(location.parkpliant_service_fee || 5.00)
      setParkMobileUsername(location.parkmobile_username || null)
      setParkMobilePassword(location.parkmobile_password || null)
      setParkMobileApiKey(location.parkmobile_api_key || null)
      setParkMobileLocationId(location.parkmobile_location_id || null)
      setParkWhizLocationId(location.parkwhizz_location_id || null)
      setParisCustomerCode(location.paris_customer_code || null)
      setParisUserId(location.paris_user_id || null)
      setParisUserPassword(location.paris_user_password || null)
      setParisFacId(location.paris_fac_id || null)
      setParkchirpEmail(location.parkchirp_email || null)
      setParkchirpPassword(location.parkchirp_password || null)
      setParkchirpFacilityId(location.parkchirp_facility_id || null)
      setParkchirpStaging(location.parkchirp_staging || false)
      setTezparkLocationId(location.tezpark_location_id || null)
      setJustparkPassesLotIds((location.justpark_passes_lot_ids || []).join('\n'))
      setHidePhotos(location.hide_photos || false)
      setIgnoreWhitelist(location.ignore_whitelist || false)
      setRequireDisputeAddress(location.require_dispute_address || false)
      setHideAmountsOnZPL(location.hide_amounts_on_zpl || false)
      setSquareToken(location.square_access_token || null)
      setSquareLocations(location.square_locations || null)
      setSquareLocationSelected(location.square_location_selected || null)
      setPaymentProcessor(location.payment_processor || 'square')
      setStripeAccountId(location.stripe_account_id || null)
      setStripeAccountStatus(location.stripe_account_status || 'not_connected')
      setShowPayDisputeMessage(location.show_pay_dispute_message || false)
      
      // Set toggle states based on which values exist
      setEarlyBirdFixedAmountToggle(location.early_bird?.fixed_amount > 0);
      setPenaltyFixedAmountToggle(location.penalty?.fixed_amount > 0);
    }
  }, [location])

  useEffect(() => {
    if (location && squareToken) {
      props.getSquareLocations(location)
    }
  }, [location, squareToken])

  useEffect(() => {
    if (squareLocationSelected && squareToken) {
      props.saveSquareLocationSelection(location, squareLocationSelected)
    }
  }, [squareLocationSelected, squareToken])

  // Stripe holds onto fetchStripeClientSecret and re-invokes it later (on its
  // own schedule) to refresh the short-lived Account Session — mirror the
  // latest client/locationId in refs so that callback never acts on a stale
  // closure if either changes after the Connect instance was created.
  const clientRef = useRef(client)
  const locationIdRef = useRef(locationId)
  useEffect(() => { clientRef.current = client }, [client])
  useEffect(() => { locationIdRef.current = locationId }, [locationId])

  const refreshStripeStatus = () => {
    return props.getStripeAccountStatus(clientRef.current, locationIdRef.current).then(result => {
      if (result?.status) {
        setStripeAccountStatus(result.status)
        setStripeCurrentlyDue(result.currentlyDue || [])
      }
    }).catch(() => {})
  }

  // Manual check for the "pending_review" state — there's no onboarding form
  // to reopen at that point (Stripe is the one doing something, not the
  // admin), so this just re-polls instead of launching the embedded flow.
  const handleCheckStripeStatus = () => {
    setStripeStatusChecking(true)
    refreshStripeStatus().finally(() => setStripeStatusChecking(false))
  }

  // Refresh the live Stripe account status once when a connected location is
  // opened, since the mirrored Firestore field can lag behind Stripe's
  // actual state (e.g. requirements added since the location was last saved).
  useEffect(() => {
    if (paymentProcessor === 'stripe' && client && locationId && location?.stripe_account_id) {
      refreshStripeStatus()
    }
  }, [paymentProcessor, client, locationId, location?.stripe_account_id])

  // Stripe invokes this itself (initial load + every session refresh) — it
  // does NOT run inside handleConnectStripe's try/catch, so errors have to be
  // surfaced from here or they vanish silently into the SDK's internals.
  const fetchStripeClientSecret = async () => {
    try {
      const result = await props.connectStripeAccount(clientRef.current, locationIdRef.current, 'US')
      setStripeAccountId(result.accountId)
      setStripeConnecting(false)
      return result.clientSecret
    } catch (err) {
      setStripeConnectError(err.message || 'Failed to start Stripe onboarding')
      setShowStripeOnboarding(false)
      setStripeConnecting(false)
      throw err
    }
  }

  const handleLinkStripeAccount = async () => {
    setStripeLinking(true)
    setStripeConnectError(null)
    try {
      const result = await props.linkStripeAccount(client, locationId, stripeLinkAccountId)
      setStripeAccountId(stripeLinkAccountId.trim())
      setStripeAccountStatus(result.status)
      setStripeLinkAccountId('')
    } catch (err) {
      setStripeConnectError(err.message || 'Failed to link Stripe account')
    } finally {
      setStripeLinking(false)
    }
  }

  const handleConnectStripe = () => {
    if (!STRIPE_PUBLISHABLE_KEY || STRIPE_PUBLISHABLE_KEY.includes('REPLACE_ME')) {
      setStripeConnectError('Stripe is not configured for this environment.')
      return
    }
    setStripeConnecting(true)
    setStripeConnectError(null)
    try {
      const instance = loadConnectAndInitialize({
        publishableKey: STRIPE_PUBLISHABLE_KEY,
        fetchClientSecret: fetchStripeClientSecret,
      })
      setStripeConnectInstance(instance)
      setShowStripeOnboarding(true)
    } catch (err) {
      setStripeConnectError(err.message || 'Failed to start Stripe onboarding')
      setStripeConnecting(false)
    }
  }

  const handleStripeOnboardingExit = () => {
    setShowStripeOnboarding(false)
    refreshStripeStatus()
  }


  useEffect(() => {
    if (locationId) {
      setLocation(props.locations.find(location => location.id === locationId))
    }
  }, [locationId])

  useEffect(() => {
    setLocations(props.locations)
  }, [props.locations])

  useEffect(() => {
    setSubtitle('Step ' + (configurationStage !== 6 ? configurationStage : 5))
  }, [configurationStage])

  const setAddressFromSearch = async place => {
    if (place) {
      let geoPlace = await geocodeByPlaceId(place.value.place_id).then(results => results[0]).catch(error => console.log(error))
      let thisLocation = await getLatLng(geoPlace).then(result => result).catch(error => console.log(error))
      let tempName = place.value.structured_formatting.main_text
      let tempAddress1 = place.value.structured_formatting.main_text
      let tempAddress2 = geoPlace.address_components.find(comp => comp.types?.indexOf('neighborhood') !== -1 || comp.types?.indexOf('administrative_area_level_3') !== -1)?.long_name || ''
      let tempCity = geoPlace.address_components.find(comp => comp.types?.indexOf('locality') !== -1 || comp.types?.indexOf('sublocality') !== -1)?.long_name
      let tempState = geoPlace.address_components.find(comp => comp.types?.indexOf('administrative_area_level_1') !== -1)?.short_name
      let tempZip = geoPlace.address_components.find(comp => comp.types?.indexOf('postal_code') !== -1)?.long_name
      setName(tempName)
      setAddress1(tempAddress1)
      setAddress2(tempAddress2)
      setCity(tempCity)
      setState(tempState)
      setZip(tempZip)
      setLat(thisLocation.lat.toString())
      setLon(thisLocation.lng.toString())
      if (!location) {
        setFirstParagraph('Your vehicle was found to be in violation of the terms of parking at ' + tempName + ', ' + tempAddress1 + ', ' + tempCity + ', ' + tempState + ' ' + tempZip)
      }
    } else {
      //setProperty(null);
    }
  }

  // Add useEffect for validation
  useEffect(() => {
    validateFields();
  }, [name, address1, city, state, zip]);

  // Separate function to update validation states
  const validateFields = () => {
    // Name validation
    setValidName(name && name.length >= 3);
    
    // Address1 validation
    setValidAddress1(address1 && address1.trim() !== '');
    
    // City validation
    setValidCity(city && city.trim() !== '');
    
    // State validation
    setValidState(state && state.trim() !== '');
    
    // Zip validation
    setValidZip(zip && zip.trim() !== '');
  };

  const nameNotValid = () => {
    // Just check validity without setting state
    if (!name || name.length < 3) {
      return true;
    }
    
    if (!address1 || address1.trim() === '') {
      return true;
    }
    
    if (!city || city.trim() === '') {
      return true;
    }
    
    if (!state || state.trim() === '') {
      return true;
    }
    
    if (!zip || zip.trim() === '') {
      return true;
    }
    
    return false;
  }

  const clientNotValid = () => {
    let isValid = true
    if (!client) {
      isValid = false
    }
    return !isValid
  }

  const updateViolations = (field, index, value, type) => {
    // Get the actual index in the full violations array (including archived ones)
    const visibleViolations = violations.filter(v => !v.is_archived);
    const visibleViolation = visibleViolations[index];
    const actualIndex = violations.findIndex(v => v === visibleViolation);

    let tempViolations = [...violations];
    if (type === 'int') {
      if (!value) {
        value = 0
      }
      value = parseInt(value)
    }
    tempViolations[actualIndex][field] = value;
    setViolations(tempViolations)
  }

  const addAnotherViolation = () => {
    let tempViolations = [...violations];
    tempViolations.push({name: null, amount: null, code: null, newItem: true, is_archived: false})
    setViolations(tempViolations)
  }

  const removeFromViolations = (index) => {
    // Get the actual index in the full violations array (including archived ones)
    const visibleViolations = violations.filter(v => !v.is_archived);
    const visibleViolation = visibleViolations[index];
    const actualIndex = violations.findIndex(v => v === visibleViolation);

    let tempViolations = [...violations];
    tempViolations[actualIndex].is_archived = true;
    setViolations(tempViolations);
  }

  const violationsNotValid = () => {
    // Filter out archived violations before validating
    const activeViolations = violations.filter(violation => !violation.is_archived);
    
    if (activeViolations.length === 0) {
      return true
    }
    let isValid = true
    activeViolations.map(violation => {
      if (!violation.name || violation.name.length < 4) {
        isValid = false
      }
      if (parseFloat(violation.amount) > 1000) {
        isValid = false
      }
    })
    return !isValid
  }

  const updateViolationRules = (field, subfield, value, type) => {
    let tempViolationRules = {...violationRules};
    if (type === 'int' && value?.length > 0) {
      value = parseInt(value)
    }
    tempViolationRules[field][subfield] = value;
    setViolationRules(tempViolationRules)
  }

  const addAgedBalanceRule = () => {
    let tempViolationRules = {...violationRules};
    tempViolationRules['aged_balance_rule'] = {conditional: 'OR', value: 3};
    setViolationRules(tempViolationRules)
  }

  const addBalanceRule = () => {
    let tempViolationRules = {...violationRules};
    tempViolationRules['balance_rule'] = {conditional: 'OR', value: 400};
    setViolationRules(tempViolationRules)
  }

  const removeAgedBalanceRule = () => {
    let tempViolationRules = {...violationRules};
    delete tempViolationRules.aged_balance_rule;
    setViolationRules(tempViolationRules)
  }

  const removeBalanceRule = () => {
    let tempViolationRules = {...violationRules};
    delete tempViolationRules.balance_rule;
    setViolationRules(tempViolationRules)
  }

  const feesAndPenaltiesNotValid = () => {
    let isValid = true
    if (parseInt(earlyBirdPercentage) > 100) {
      isValid = false
    }
    if (parseInt(penaltyPercentage) > 100) {
      isValid = false
    }
    const penaltyAmountSet = penaltyFixedAmountToggle
      ? parseFloat(penaltyFixedAmount) > 0
      : parseInt(penaltyPercentage) > 0
    if (penaltyAmountSet && parseInt(penaltyDays) === 0) {
      isValid = false
    }
    return !isValid
  }

  const violationRulesNotValid = () => {
    let isValid = true
    if (violationRules.citation_rule.citations?.length === 0) {
      isValid = false
    }
    if (violationRules.citation_rule.months?.length === 0) {
      isValid = false
    }
    if (violationRules.aged_balance_rule?.conditional?.length === 0) {
      isValid = false
    }
    if (violationRules.aged_balance_rule?.value?.length === 0) {
      isValid = false
    }
    if (violationRules.balance_rule?.conditional?.length === 0) {
      isValid = false
    }
    if (violationRules.balance_rule?.value?.length === 0) {
      isValid = false
    }
    return !isValid
  }

  const addLocation = () => {
    props.addLocation({client, active, name, address1, address2, city, state, zip, lat, lon, earlyBirdDays, earlyBirdPercentage, penaltyDays, penaltyPercentage, writeOffDays, violations, officerAlertMessage, violationRules, footerText, citationTerm, firstParagraph, warningTerm, t2LocationId, parklyncApiKey, parklyncLocationId, spotheroLocationId, parkpliantUsername, parkpliantPassword, parkpliantIanaTimezone, parkpliantSendDays, parkMobileUsername, parkMobilePassword, parkMobileApiKey, parkMobileLocationId, parkWhizLocationId, parisCustomerCode, parisUserId, parisUserPassword, parisFacId, parkchirpEmail, parkchirpPassword, parkchirpFacilityId, parkchirpStaging, tezparkLocationId, justparkPassesLotIds, hidePhotos, ignoreWhitelist, showPayDisputeMessage, hideAmountsOnZPL, earlyBirdFixedAmount, penaltyFixedAmount, requireDisputeAddress}, (locationData) => {
      // Don't try to set location state, as the page will reload
      // Just redirect to the edit location page with the integration tab (stage 5) active
      window.location.href = `/edit-location/${locationData.id}?stage=5`;
    })
  }

  const updateLocation = () => {
    props.editLocation(location, {client, active, name, address1, address2, city, state, zip, lat, lon, earlyBirdDays, earlyBirdPercentage, penaltyDays, penaltyPercentage, writeOffDays, violations, officerAlertMessage, violationRules, footerText, citationTerm, firstParagraph, warningTerm, t2LocationId, parklyncApiKey, parklyncLocationId, spotheroLocationId, parkpliantUsername, parkpliantPassword, parkpliantIanaTimezone, parkpliantSendDays, parkpliantServiceFee, parkMobileUsername, parkMobilePassword, parkMobileApiKey, parkMobileLocationId, parkWhizLocationId, parisCustomerCode, parisUserId, parisUserPassword, parisFacId, parkchirpEmail, parkchirpPassword, parkchirpFacilityId, parkchirpStaging, tezparkLocationId, justparkPassesLotIds, hidePhotos, ignoreWhitelist, showPayDisputeMessage, hideAmountsOnZPL, earlyBirdFixedAmount, penaltyFixedAmount, requireDisputeAddress, paymentProcessor}, () => window.location.href='/locations')
  }

  const renderConfiguratorStage = () => {
    // If stage 5 is selected but location isn't loaded yet, check if we have a locationId
    if (configurationStage === 5 && !location && locationId) {
      return (
        <div className="p-4 text-center">
          <h5>Loading integration details...</h5>
          <p className="text-muted mt-3">Please wait while the location information is being loaded.</p>
        </div>
      );
    }
    
    switch (configurationStage) {
      case 1:
        return renderStage1();
      case 2:
        return renderStage2();
      case 3:
        return renderStage3();
      case 4:
        return renderStage4();
      case 5:
      default:  
        return renderStage5();  
    }
  }

  const renderViolations = () => {
    // Get only non-archived violations
    const activeViolations = violations.filter(violation => !violation.is_archived);
    
    return activeViolations.map((violation, idx) => (
      <Card className="mb-3 shadow-sm" key={idx}>
        <CardBody>
          <Row>
            <Col xs={12} md={4}>
              <div className="form-input-group mb-md-0">
                <label htmlFor={`violation-${idx}`} className="form-label-custom">Violation name</label>
                <FormInput
                  id={`violation-${idx}`}
                  placeholder="Violation name"
                  value={violation.name}
                  disabled={location && !violation.newItem}
                  onChange={(event) => updateViolations('name', idx, event.target.value)}
                />
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="form-input-group mb-md-0">
                <label htmlFor={`amount-${idx}`} className="form-label-custom">
                  Amount <span className="text-muted">(0 for Warning)</span>
                </label>
                <div className="d-flex align-items-center">
                  <span style={{ 
                    fontSize: '1rem', 
                    marginRight: '8px', 
                    color: '#495057', 
                    fontWeight: '500' 
                  }}>$</span>
                  <FormInput
                    id={`amount-${idx}`}
                    placeholder="Amount"
                    value={violation.amount}
                    disabled={!violation.newItem}
                    onChange={(event) => updateViolations('amount', idx, event.target.value.replace(/[^.\d]/g, ''), 'int')}
                  />
                </div>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <div className="form-input-group mb-md-0">
                <label htmlFor={`code-${idx}`} className="form-label-custom">
                  Violation Code <span className="text-muted">(optional)</span>
                  <span className="tooltip-container ml-2">
                    <FontAwesomeIcon 
                      icon={faInfoCircle} 
                      style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                    />
                    <div className="tooltip-content" style={{ width: '280px' }}>
                      <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Violation Codes</div>
                      <p style={{ margin: 0 }}>
                        This can be a municipal code or reference number that will be displayed on the printed citation. It helps identify the specific regulation or ordinance that was violated.
                      </p>
                    </div>
                  </span>
                </label>
                <FormInput
                  id={`code-${idx}`}
                  placeholder="Code"
                  value={violation.code}
                  disabled={location && !violation.newItem}
                  onChange={(event) => updateViolations('code', idx, event.target.value)}
                />
              </div>
            </Col>
          </Row>
          
          <Row className="mt-3">
            <Col xs={12} className="text-right">
              {/* Show Remove button on all violations if there's more than one active violation */}
              {activeViolations.length > 1 && (
                <Button
                  theme="danger"
                  outline
                  size="sm"
                  className="mr-2"
                  onClick={() => removeFromViolations(idx)}
                >
                  Remove
                </Button>
              )}
              <Button
                theme="accent"
                outline
                size="sm"
                onClick={() => addAnotherViolation()}
              >
                Add another violation
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    ));
  }

  const renderStage1 = () => {
    return (
      <div className="form-section">
        <h4 className="section-title">Location Details</h4>
        
        {/* Google Places Autocomplete */}
        <Card className="mb-4 shadow-sm">
          <CardBody>
            <div className="form-input-group">
              <label htmlFor="feFindProperty" className="form-label-custom">Find Address</label>
              <p className="text-muted mb-3" style={{fontSize: '0.85rem'}}>
                Search for a property using our Google integration to automatically fill in address fields.
              </p>
              <GooglePlacesAutocomplete
                ref={addressSelector}
                apiKey="AIzaSyAs4SS_IliPH7OVWUd5rz57mMGQOm3aswQ"
                selectProps={{
                  value: location ? location.name : null,
                  onChange: setAddressFromSearch,
                  placeholder: "Start typing an address...",
                  isClearable: true,
                }}
                apiOptions={{ language: 'US', region: 'US' }}
                autocompletionRequest={{componentRestrictions: {country: 'US'}}}
              />
            </div>
          </CardBody>
        </Card>
        
        {/* Location Name */}
        <div className="form-input-group">
          <label htmlFor="feName" className="form-label-custom">
            Location name <span className="required-indicator">*</span>
            <span className="tooltip-container ml-2">
              <FontAwesomeIcon 
                icon={faInfoCircle} 
                style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
              />
              <div className="tooltip-content">
                <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>What should I enter here?</div>
                <p style={{ margin: 0 }}>Enter the name that people most commonly use to recognize this location. This could be a business name, property name, or any identifier that makes the location easily identifiable to users.</p>
              </div>
            </span>
          </label>
          <FormInput
            id='feName'
            onChange={event => setName(event.target.value)}
            placeholder='Location name'
            value={name}
            invalid={validName === false}
          />
          <FormFeedback>Please enter a valid name.</FormFeedback>
        </div>
        
        {/* Address Fields */}
        <Row>
          <Col lg={6}>
            <div className="form-input-group">
              <label htmlFor="feAddress1" className="form-label-custom">
                Address 1 <span className="required-indicator">*</span>
              </label>
              <FormInput
                id="feAddress1"
                placeholder="Address 1"
                value={address1}
                onChange={(event) => setAddress1(event.target.value)}
                invalid={validAddress1 === false}
              />
              <FormFeedback>Address is required.</FormFeedback>
            </div>
          </Col>
          <Col lg={6}>
            <div className="form-input-group">
              <label htmlFor="feAddress2" className="form-label-custom">
                Address 2
              </label>
              <FormInput
                id="feAddress2"
                placeholder="Address 2"
                value={address2}
                onChange={(event) => setAddress2(event.target.value)}
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={4}>
            <div className="form-input-group">
              <label htmlFor="feCity" className="form-label-custom">
                City <span className="required-indicator">*</span>
              </label>
              <FormInput
                id="feCity"
                placeholder="City"
                value={city}
                onChange={(event) => setCity(event.target.value)}
                invalid={validCity === false}
              />
              <FormFeedback>City is required.</FormFeedback>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-input-group">
              <label htmlFor="feState" className="form-label-custom">
                State <span className="required-indicator">*</span>
              </label>
              <FormInput
                id="feState"
                placeholder="State"
                value={state}
                onChange={(event) => setState(event.target.value)}
                invalid={validState === false}
              />
              <FormFeedback>State is required.</FormFeedback>
            </div>
          </Col>
          <Col lg={4}>
            <div className="form-input-group">
              <label htmlFor="feZip" className="form-label-custom">
                Zip <span className="required-indicator">*</span>
              </label>
              <FormInput
                id="feZip"
                placeholder="Zip"
                value={zip}
                onChange={(event) => setZip(event.target.value)}
                invalid={validZip === false}
              />
              <FormFeedback>Zip code is required.</FormFeedback>
            </div>
          </Col>
        </Row>
        
        {/* Client Selection */}
        {props.user.type === 'super' && (
          <div className="form-input-group">
            <label htmlFor="feClient" className="form-label-custom">Client</label>
            <FormSelect 
              id="feClient" 
              value={client} 
              onChange={event => setClient(event.target.value)}
            >
              <option value={null}>Select</option>
              {props.clients.filter(client => ((!location || !location.id) && client.active) || (location && location.id && client)).sort((a, b) => a.name.localeCompare(b.name)).map(client => (
                <option value={client.id}>{client.name}</option>
              ))}
            </FormSelect>
          </div>
        )}
        
        {/* Active toggle */}
        <div className="form-input-group">
          <label htmlFor="feActive" className="form-label-custom d-flex align-items-center">
            Active
            <FormCheckbox
              id="feActive"
              toggle
              checked={active}
              onChange={() => setActive(!active)}
              className="ml-2"
            />
          </label>
        </div>
        
        {/* Action buttons */}
        <div className="form-footer">
          <Button
            className="mr-2"
            theme="light"
            onClick={() => window.location.href='/locations'}
          >
            Cancel
          </Button>
          <Button
            theme="accent"
            disabled={nameNotValid() || clientNotValid()}
            onClick={() => {
              if (!!location) {
                updateLocation()
              } else {
                setConfigurationStage(2)
              }
            }}
          >
            {!!location ? 'Save' : 'Next'}
          </Button>
        </div>
      </div>
    );
  }

  const renderStage2 = () => {
    return (
      <div className="form-section">
        <h4 className="section-title">Violation Rules</h4>
        
        <Row className="mb-4">
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <CardBody>
                <h5 className="mb-3 text-center font-weight-bold">Early Payment Discount</h5>
                <Row style={{marginTop: 16, marginBottom: 12}}>
                  <Col xs={6} className={'pr-0'} style={{paddingTop: 4}}><span className="mr-2 mb-0">If paid within</span></Col>
                  <Col xs={2} className={'pr-0 pl-0'}>
                    <FormInput
                      id="paidWithin"
                      value={earlyBirdDays}
                      onChange={(event) => setEarlyBirdDays(event.target.value.replace(/\D/, ''))}
                      style={{paddingLeft: 5, paddingRight: 5}}
                    />
                  </Col>
                  <Col xs={4} style={{paddingTop: 4}}><span className="mr-2 mb-0">days</span></Col>
                </Row>
                
                <Row className="mb-2">
                  <Col xs={12}>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className={`mr-2 ${!earlyBirdFixedAmountToggle ? 'font-weight-bold text-success' : 'text-muted'}`} style={{ fontSize: '0.85rem' }}>
                        Percentage
                      </div>
                      <FormCheckbox
                        toggle
                        checked={earlyBirdFixedAmountToggle}
                        onChange={() => {
                          setEarlyBirdFixedAmountToggle(!earlyBirdFixedAmountToggle);
                          if (earlyBirdFixedAmountToggle) {
                            setEarlyBirdFixedAmount(0);
                          } else {
                            setEarlyBirdPercentage(0);
                          }
                        }}
                        style={{ margin: '0 8px' }}
                      />
                      <div className={`ml-2 ${earlyBirdFixedAmountToggle ? 'font-weight-bold text-success' : 'text-muted'}`} style={{ fontSize: '0.85rem' }}>
                        Fixed Amount
                      </div>
                    </div>
                  </Col>
                </Row>
                
                {!earlyBirdFixedAmountToggle ? (
                  <Row>
                    <Col xs={6} className={'pr-0'} style={{paddingTop: 4}}><span className="mr-2 mb-0">Apply discount of</span></Col>
                    <Col xs={2} className={'pr-0 pl-0'}>
                      <FormInput
                        id="paidPercentage"
                        value={earlyBirdPercentage}
                        onChange={(event) => setEarlyBirdPercentage(event.target.value.replace(/\D/, ''))}
                        style={{paddingLeft: 5, paddingRight: 5}}
                      />
                    </Col>
                    <Col xs={4} style={{paddingTop: 4}}><span className="mr-2 mb-0">percent</span></Col>
                  </Row>
                ) : (
                  <Row style={{marginTop: 12, marginBottom: 8}}>
                    <Col xs={6} className={'pr-0'}><span className="mr-2 mb-0">Apply a fixed discount of</span></Col>
                    <Col xs={2} className={'pr-0 pl-0'}>
                      <div className="d-flex align-items-center">
                        <span style={{ 
                          fontSize: '0.9rem', 
                          marginRight: '4px', 
                          color: '#495057', 
                          fontWeight: '500' 
                        }}>$</span>
                        <FormInput
                          id="earlyBirdFixedAmount"
                          value={earlyBirdFixedAmount}
                          onChange={(event) => setEarlyBirdFixedAmount(event.target.value.replace(/\D/, ''))}
                          style={{paddingLeft: 5, paddingRight: 5}}
                        />
                      </div>
                    </Col>
                    <Col xs={4} style={{paddingTop: 4}}></Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
          
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <CardBody>
                <h5 className="mb-3 text-center font-weight-bold">Penalty</h5>
                <Row style={{marginTop: 16, marginBottom: 12}}>
                  <Col xs={6} className={'pr-0'} style={{paddingTop: 4}}><span className="mr-2 mb-0">If NOT paid within</span></Col>
                  <Col xs={2} className={'pr-0 pl-0'}>
                    <FormInput
                      id="notPaidWithin"
                      value={penaltyDays}
                      onChange={(event) => setPenaltyDays(event.target.value.replace(/\D/, ''))}
                      style={{
                        paddingLeft: 5, paddingRight: 5,
                        borderColor: (penaltyFixedAmountToggle ? parseFloat(penaltyFixedAmount) > 0 : parseInt(penaltyPercentage) > 0) && parseInt(penaltyDays) === 0 ? '#dc3545' : undefined
                      }}
                    />
                  </Col>
                  <Col xs={4} style={{paddingTop: 4}}><span className="mr-2 mb-0">days</span></Col>
                </Row>
                
                <Row className="mb-2">
                  <Col xs={12}>
                    <div className="d-flex align-items-center justify-content-center">
                      <div className={`mr-2 ${!penaltyFixedAmountToggle ? 'font-weight-bold text-success' : 'text-muted'}`} style={{ fontSize: '0.85rem' }}>
                        Percentage
                      </div>
                      <FormCheckbox
                        toggle
                        checked={penaltyFixedAmountToggle}
                        onChange={() => {
                          setPenaltyFixedAmountToggle(!penaltyFixedAmountToggle);
                          if (penaltyFixedAmountToggle) {
                            setPenaltyFixedAmount(0);
                          } else {
                            setPenaltyPercentage(0);
                          }
                        }}
                        style={{ margin: '0 8px' }}
                      />
                      <div className={`ml-2 ${penaltyFixedAmountToggle ? 'font-weight-bold text-success' : 'text-muted'}`} style={{ fontSize: '0.85rem' }}>
                        Fixed Amount
                      </div>
                    </div>
                  </Col>
                </Row>
                
                {!penaltyFixedAmountToggle ? (
                  <Row>
                    <Col xs={6} className={'pr-0'} style={{paddingTop: 4}}><span className="mr-2 mb-0">Increase by</span></Col>
                    <Col xs={2} className={'pr-0 pl-0'}>
                      <FormInput
                        id="penaltyPercentage"
                        value={penaltyPercentage}
                        onChange={(event) => setPenaltyPercentage(event.target.value.replace(/\D/, ''))}
                        style={{paddingLeft: 5, paddingRight: 5}}
                      />
                    </Col>
                    <Col xs={4} style={{paddingTop: 4}}><span className="mr-2 mb-0">percent</span></Col>
                  </Row>
                ) : (
                  <Row style={{marginTop: 12, marginBottom: 8}}>
                    <Col xs={6} className={'pr-0'} style={{paddingTop: 4}}><span className="mr-2 mb-0">Increase to</span></Col>
                    <Col xs={2} className={'pr-0 pl-0'}>
                      <div className="d-flex align-items-center">
                        <span style={{ 
                          fontSize: '0.9rem', 
                          marginRight: '4px', 
                          color: '#495057', 
                          fontWeight: '500' 
                        }}>$</span>
                        <FormInput
                          id="penaltyFixedAmount"
                          value={penaltyFixedAmount}
                          onChange={(event) => setPenaltyFixedAmount(event.target.value.replace(/\D/, ''))}
                          style={{paddingLeft: 5, paddingRight: 5}}
                        />
                      </div>
                    </Col>
                    <Col xs={4} style={{paddingTop: 4}}></Col>
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
          
          <Col md={4}>
            <Card className="h-100 shadow-sm">
              <CardBody>
                <h5 className="mb-3 text-center font-weight-bold">Write Off</h5>
                <div className="form-input-group">
                  <div className="d-flex align-items-center mb-2">
                    <label className="mr-2 mb-0" style={{minWidth: '130px'}}>If NOT paid within</label>
                    <div className="d-flex align-items-center">
                      <FormInput
                        id="writeOffWithin"
                        value={writeOffDays}
                        onChange={(event) => setWriteOffDays(event.target.value.replace(/\D/, ''))}
                        style={{width: '60px', textAlign: 'center'}}
                      />
                      <span className="ml-2">days</span>
                    </div>
                  </div>
                  
                  <div className="mt-2">
                    <span>Write off the debt</span>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
        
        <div className="mb-4">
          <Card className="h-100 shadow-sm"> 
            <CardBody>
              <h5 className="mb-3 font-weight-bold">Advanced</h5>
              <div className="form-input-group mb-0">
                <label htmlFor="ignoreWhitelist" className="form-label-custom d-flex align-items-center">
                  <span>Ignore vehicles not on the white list when scanning</span>
                  <FormCheckbox
                    id="ignoreWhitelist"
                    toggle
                    checked={ignoreWhitelist}
                    onChange={() => setIgnoreWhitelist(!ignoreWhitelist)}
                    className="ml-2"
                  />
                </label>
                <p className="text-muted" style={{fontSize: '0.85rem'}}>
                  Enable this option to check vehicles parked out of their assigned zone.
                </p>
              </div>
              
              <div className="form-input-group mb-0">
                <label htmlFor="requireDisputeAddress" className="form-label-custom d-flex align-items-center">
                  <span>Require address on dispute</span>
                  <FormCheckbox
                    id="requireDisputeAddress"
                    toggle
                    checked={requireDisputeAddress}
                    onChange={() => setRequireDisputeAddress(!requireDisputeAddress)}
                    className="ml-2"
                  />
                </label>
                <p className="text-muted" style={{fontSize: '0.85rem'}}>
                  When enabled, customers must provide their address when submitting a dispute for this location.
                </p>
              </div>
            </CardBody>
          </Card>
        </div>
        
        <h4 className="section-title d-flex align-items-center">
          Violation Types
          <span className="tooltip-container ml-2">
            <FontAwesomeIcon 
              icon={faInfoCircle} 
              style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
            />
            <div className="tooltip-content" style={{ width: '300px' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>What are Violation Types?</div>
              <p style={{ margin: 0 }}>
                You can create as many violation types as you need. These are the specific infractions that officers can select in the app when issuing a parking ticket. Each violation can have its own name, fine amount, and optional code.
              </p>
            </div>
          </span>
        </h4>
        
        {renderViolations()}
        
        <div className="form-footer">
          <Button
            className="mr-2"
            theme="light"
            onClick={() => window.location.href='/locations'}
          >
            Cancel
          </Button>
          <Button
            theme="accent"
            disabled={violationsNotValid() || feesAndPenaltiesNotValid()}
            onClick={() => {
              if (!!location) {
                updateLocation()
              } else {
                setConfigurationStage(3)
              }
            }}
          >
            {!!location ? 'Save' : 'Next'}
          </Button>
        </div>
      </div>
    );
  }

  const renderStage3 = () => {
    return (
      <>
        <Row className={'mb-2'}>
          <Col>
            <Card className={'p-3 pb-4'}>
              <Row>
                <Col xs={12}>
                  <label htmlFor="feCity" className="form-label-custom">
                    Officer alert message
                    <span className="tooltip-container ml-2">
                      <FontAwesomeIcon 
                        icon={faInfoCircle} 
                        style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                      />
                      <div className="tooltip-content" style={{ width: '280px' }}>
                        <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Alert Messages</div>
                        <p style={{ margin: 0 }}>
                          This message will be displayed to enforcement officers in the app when they scan a vehicle that matches the defined alert rules below. It helps officers take appropriate action for frequent violators.
                        </p>
                      </div>
                    </span>
                  </label>
                  <FormInput
                    id={'officerAlert'}
                    placeholder={'Officer alert message'}
                    value={officerAlertMessage}
                    onChange={(event) => setOfficerAlertMessage(event.target.value.substr(0, 400))}
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} className={'text-right'}>
                  <span style={{fontSize: 10}}>{400 - officerAlertMessage.length} characters remaining</span>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        <Row className={'mb-2'}>
          <Col>
            <Card className={'p-3 pb-4'}>
              <Row>
                <Col xs={12}>
                  <label htmlFor="feCity" className="form-label-custom">{'Alert officer (citation rule)'}</label>
                  <Row className={'mt-2'}>
                    <Col lg={6}>
                      <Row className={'pb-2'}>
                        <Col sm={8}  style={{paddingTop: 4}}>
                          <span style={{fontSize: 11}}>IF vehicle has been issued more than</span>
                        </Col>
                        <Col sm={2} className={'pr-0 pl-0'}>
                          <FormInput
                            id={'violationRuleCitationCitations'}
                            value={violationRules.citation_rule.citations}
                            style={{paddingLeft: 5, paddingRight: 5}}
                            onChange={(event) => updateViolationRules('citation_rule', 'citations', event.target.value.replace(/\D/, ''), 'int')}
                          />
                        </Col>
                        <Col sm={2} className={'pr-0'} style={{paddingTop: 4}}>
                          <span style={{fontSize: 11}}>citations</span>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm={8} className={'pr-0'} style={{paddingTop: 4}}>
                          <span style={{fontSize: 11}}>In the past</span>
                        </Col>
                        <Col sm={2} className={'pr-0 pl-0'}>
                          <FormInput
                            id={'violationRuleCitationMonths'}
                            value={violationRules.citation_rule.months}
                            style={{paddingLeft: 5, paddingRight: 5}}
                            onChange={(event) => updateViolationRules('citation_rule', 'months', event.target.value.replace(/\D/, ''), 'int')}
                          />
                        </Col>
                        <Col sm={2} className={'pr-0'} style={{paddingTop: 4}}>
                          <span style={{fontSize: 11}}>months</span>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg={6}>
                      <Col xs={12} className={'text-right'} style={{paddingTop: 59}}>
                        {!violationRules.aged_balance_rule && (
                          <Button
                            theme="outline-accent"
                            className="mr-1"
                            onClick={() => addAgedBalanceRule()}
                          >
                            Add aged balance rule
                            <span className="tooltip-container ml-2">
                              <FontAwesomeIcon 
                                icon={faInfoCircle} 
                                style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                              />
                              <div className="tooltip-content" style={{ width: '280px' }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Aged Balance Rule</div>
                                <p style={{ margin: 0 }}>
                                  This rule alerts officers when a scanned vehicle has outstanding citations older than the defined time period. It helps identify vehicles with long-unpaid citations.
                                </p>
                              </div>
                            </span>
                          </Button>
                        )}
                        {!violationRules.balance_rule && (
                          <Button
                            theme="outline-accent"
                            onClick={() => addBalanceRule()}
                          >
                            Add balance rule
                            <span className="tooltip-container ml-2">
                              <FontAwesomeIcon 
                                icon={faInfoCircle} 
                                style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                              />
                              <div className="tooltip-content" style={{ width: '280px' }}>
                                <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Balance Rule</div>
                                <p style={{ margin: 0 }}>
                                  This rule alerts officers when a scanned vehicle has outstanding balance from previous citations greater than the defined amount. Helps identify vehicles with significant unpaid debt.
                                </p>
                              </div>
                            </span>
                          </Button>
                        )}
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
        {violationRules?.balance_rule && (
          <Row className={'mb-2'}>
            <Col>
              <Card className={'p-3 pb-4'}>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="feCity" className="form-label-custom">{'Alert officer (balance rule)'}</label>
                    <Row className={'mt-2'}>
                      <Col lg={6}>
                        <Row className={'pb-2'}>
                          <Col sm={3} className={'pr-0'}>
                            <FormSelect value={violationRules.balance_rule.conditional} onChange={(event) => updateViolationRules('balance_rule', 'conditional', event.target.value)}>
                              <option value={'OR'}>OR</option>
                              <option value={'AND'}>AND</option>
                            </FormSelect>
                          </Col>
                          <Col sm={7} className={'pr-0'} style={{paddingTop: 4}}>
                            <span style={{fontSize: 11}}>outstanding balance is greater than</span>
                          </Col>
                          <Col sm={2} className={'pr-0 pl-0'}>
                            <FormInput
                              id={'violationRuleAgedBalance'}
                              value={violationRules.balance_rule.value}
                              style={{paddingLeft: 5, paddingRight: 5}}
                              onChange={(event) => updateViolationRules('balance_rule', 'value', event.target.value.replace(/\D/, ''), 'int')}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={6}>
                        <Col xs={12} className={'text-right'} style={{paddingTop: 59}}>
                          <Button
                            theme="outline-secondary"
                            className="mr-1"
                            onClick={() => removeBalanceRule()}
                          >Remove</Button>
                          {!violationRules?.aged_balance_rule && (
                            <Button
                              theme="outline-accent"
                              onClick={() => addAgedBalanceRule()}
                            >Add aged balance rule</Button>
                          )}
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        )}
        {violationRules?.aged_balance_rule && (
          <Row className={'mb-2'}>
            <Col>
              <Card className={'p-3 pb-4'}>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="feCity" className="form-label-custom">{'Alert officer (aged balance rule)'}</label>
                    <Row className={'mt-2'}>
                      <Col lg={7}>
                        <Row className={'pb-2'}>
                          <Col sm={3} className={'pr-0'}>
                            <FormSelect value={violationRules.aged_balance_rule.conditional} onChange={(event) => updateViolationRules('aged_balance_rule', 'conditional', event.target.value)}>
                              <option value={'OR'}>OR</option>
                              <option value={'AND'}>AND</option>
                            </FormSelect>
                          </Col>
                          <Col sm={6} className={'pr-0'} style={{paddingTop: 4}}>
                            <span style={{fontSize: 11}}>outstanding balance is older than</span>
                          </Col>
                          <Col sm={1} className={'pr-0 pl-0'}>
                            <FormInput
                              id={'violationRuleAgedBalance'}
                              value={violationRules.aged_balance_rule.value}
                              style={{paddingLeft: 5, paddingRight: 5}}
                              onChange={(event) => updateViolationRules('aged_balance_rule', 'value', event.target.value.replace(/\D/, ''), 'int')}
                            />
                          </Col>
                          <Col sm={2} className={'pr-0'} style={{paddingTop: 4}}>
                            <span style={{fontSize: 11}}>months</span>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={5}>
                        <Col xs={12} className={'text-right'} style={{paddingTop: 59}}>
                          <Button
                            theme="outline-secondary"
                            className="mr-1"
                            onClick={() => removeAgedBalanceRule()}
                          >Remove</Button>
                          {!violationRules?.balance_rule && (
                            <Button
                              theme="outline-accent"
                              onClick={() => addBalanceRule()}
                            >
                              Add balance rule
                              <span className="tooltip-container ml-2">
                                <FontAwesomeIcon 
                                  icon={faInfoCircle} 
                                  style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                                />
                                <div className="tooltip-content" style={{ width: '280px' }}>
                                  <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Balance Rule</div>
                                  <p style={{ margin: 0 }}>
                                    This rule alerts officers when a scanned vehicle has outstanding balance from previous citations greater than the defined amount. Helps identify vehicles with significant unpaid debt.
                                  </p>
                                </div>
                              </span>
                            </Button>
                          )}
                        </Col>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        )}
        <Row className={'mt-4'}>
          <Col>
            <Form>
              <Row form>
                <Col md="12" className="form-group text-right">
                  <Button
                    className="mr-1"
                    theme="secondary"
                    onClick={() => window.location.href='/locations'}
                  >Cancel</Button>
                  <Button
                    theme="accent"
                    disabled={violationRulesNotValid()}
                    onClick={() => {
                      if (!!location) {
                        setConfigurationStage(4)
                        updateLocation()
                      } else {
                        setConfigurationStage(4)
                      }
                    }}
                    className="mr-3"
                  >{!!location ? 'Save' : 'Next'}</Button>
                </Col>
              </Row>                        
            </Form>
          </Col>
        </Row>
      </>
    )
  }

  const renderStage4 = () => {
    return (
      <>
        <Card className={'p-3 pb-4'}>
          <Row>
            <Col>
              <Form>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="fefooterText" className="form-label-custom">
                      Customer facing "Citation" term
                      <span className="tooltip-container ml-2">
                        <FontAwesomeIcon 
                          icon={faInfoCircle} 
                          style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                        />
                        <div className="tooltip-content" style={{ width: '280px' }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Citation Term</div>
                          <p style={{ margin: 0 }}>
                            This term will appear on the printed parking ticket as well as the dispute portal. You can customize it to match your internal terminology.
                          </p>
                        </div>
                      </span>
                    </label>
                    <FormInput
                      id={'titleText'}
                      placeholder={'Enter the term to replace "Citation" for customers'}
                      value={citationTerm}
                      onChange={(event) => setCitationTerm(event.target.value.substr(0, 20))}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className={'text-right'}>
                    <span style={{fontSize: 10}}>{20 - citationTerm.length} characters remaining</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="fefooterText" className="form-label-custom">
                      Customer facing "Warning" term
                      <span className="tooltip-container ml-2">
                        <FontAwesomeIcon 
                          icon={faInfoCircle} 
                          style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                        />
                        <div className="tooltip-content" style={{ width: '280px' }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Warning Term</div>
                          <p style={{ margin: 0 }}>
                            This term will appear on the printed parking ticket when there is not a paid violation, as well as on the dispute portal. You can customize it to match your internal terminology.
                          </p>
                        </div>
                      </span>
                    </label>
                    <FormInput
                      id={'warningText'}
                      placeholder={'Enter the term to replace "Warning" for customers'}
                      value={warningTerm}
                      onChange={(event) => setWarningTerm(event.target.value.substr(0, 20))}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className={'text-right'}>
                    <span style={{fontSize: 10}}>{20 - warningTerm.length} characters remaining</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="fefooterText" className="form-label-custom">
                      First paragraph on printed citation
                      <span className="tooltip-container ml-2">
                        <FontAwesomeIcon 
                          icon={faInfoCircle} 
                          style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                        />
                        <div className="tooltip-content" style={{ width: '280px' }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About First Paragraph</div>
                          <p style={{ margin: 0 }}>
                            You can edit the intro language used on the printed citations. This paragraph appears at the top of the citation to explain the violation to the customer.
                          </p>
                        </div>
                      </span>
                    </label>
                    <FormTextarea
                      id={'firstParagraph'}
                      placeholder={'Enter text to appear in the first paragraph of the printed citation'}
                      value={firstParagraph}
                      style={{height: 80}}
                      
                      onChange={(event) => setFirstParagraph(event.target.value.substr(0, 200))}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className={'text-right'}>
                    <span style={{fontSize: 10}}>{200 - firstParagraph.length} characters remaining</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="fefooterText" className="form-label-custom">
                      Citation contact info
                      <span className="tooltip-container ml-2">
                        <FontAwesomeIcon 
                          icon={faInfoCircle} 
                          style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                        />
                        <div className="tooltip-content" style={{ width: '280px' }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Contact Info</div>
                          <p style={{ margin: 0 }}>
                            Some states or cities require any private or public company issuing a parking ticket to include contact information. This will appear at the bottom of the printed citation.
                          </p>
                        </div>
                      </span>
                    </label>
                    <FormInput
                      id={'footerText'}
                      placeholder={'Enter details to appear at the bottom of the printed citation'}
                      value={footerText}
                      onChange={(event) => setFooterText(event.target.value.substr(0, 100))}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} className={'text-right'}>
                    <span style={{fontSize: 10}}>{100 - footerText.length} characters remaining</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="fefooterText" className="form-label-custom">
                      Hide photographs from citation
                      <span className="tooltip-container ml-2">
                        <FontAwesomeIcon 
                          icon={faInfoCircle} 
                          style={{ color: '#21AA73', cursor: 'help', fontSize: '16px' }} 
                        />
                        <div className="tooltip-content" style={{ width: '280px' }}>
                          <div style={{ fontWeight: 'bold', marginBottom: '3px' }}>About Photo Display</div>
                          <p style={{ margin: 0 }}>
                            By default, we will include license plate scans and additional photos wherever possible on the citations unless you toggle this to ON. This affects both printed citations and the dispute portal.
                          </p>
                        </div>
                      </span>
                    </label>
                    <FormCheckbox
                        toggle
                        checked={hidePhotos}
                        onChange={() => setHidePhotos(!hidePhotos)}
                      >
                    </FormCheckbox>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="showPayDisputeMessage" className="form-label-custom">Show 'Please pay or dispute...' message on the citation</label>
                    <FormCheckbox
                      id="showPayDisputeMessage"
                      toggle
                      checked={showPayDisputeMessage}
                      onChange={() => setShowPayDisputeMessage(!showPayDisputeMessage)}
                    >
                    </FormCheckbox>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <label htmlFor="hideAmountsOnZPL" className="form-label-custom">Hide citation and violation amounts on thermal (ZPL) printouts</label>
                    <FormCheckbox
                      id="hideAmountsOnZPL"
                      toggle
                      checked={hideAmountsOnZPL}
                      onChange={() => setHideAmountsOnZPL(!hideAmountsOnZPL)}
                    >
                    </FormCheckbox>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Card>
        <Row className={'mt-4'}>
          <Col>
            <Form>
              <Row form>
                <Col md="12" className="form-group text-right">
                  <Button
                    className="mr-1"
                    theme="secondary"
                    onClick={() => window.location.href='/locations'}
                  >Cancel</Button>
                  <Button
                    theme="accent"
                    //disabled={violationRulesNotValid()}
                    onClick={() => {
                      if (!!location) {
                        //setConfigurationStage(5)
                        updateLocation()
                      } else {
                        //setConfigurationStage(5)
                        addLocation()
                      }
                    }}
                  >Save</Button>
                </Col>
              </Row>                        
            </Form>
          </Col>
        </Row>
      </>
    )
  }

  const renderStage5 = () => {
    // Add a nicer loading state with EnforcePlus styling
    if (!location && locationId) {
      return (
        <div className="p-5 text-center">
          <div style={{ marginBottom: '1.5rem' }}>
            <div style={{ 
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: 'rgba(33, 170, 115, 0.1)',
              color: '#21AA73',
              fontSize: '24px'
            }}>
              <NoteAddIcon fontSize="inherit" />
            </div>
          </div>
          <h5 style={{ color: '#3d5170', fontWeight: 600, marginBottom: '1rem' }}>Loading Integration Details</h5>
          <p className="text-muted" style={{ fontSize: '0.9rem', maxWidth: '400px', margin: '0 auto 1.5rem' }}>
            Please wait while we load the integration settings for this location. This should only take a moment.
          </p>
          <div className="spinner-border spinner-border-sm text-success" role="status" style={{ marginRight: '0.5rem' }}>
            <span className="sr-only">Loading...</span>
          </div>
          <span className="text-muted" style={{ fontSize: '0.85rem' }}>Loading data...</span>
        </div>
      );
    }
    
    // If no locationId, redirect to locations
    if (!location && !locationId) {
      window.location.href = '/locations';
      return null;
    }
    
    return (
      <>
        <Row className="mb-4">
          <Col>
            <Card className="shadow-sm">
              <CardBody>
                <h5 className="font-weight-bold mb-3">API Integration Details</h5>
                <p className="text-muted mb-4">
                  Use these credentials to integrate this location with your own systems or third-party services.
                </p>
                
                <Form>
                  <Row form>
                    <Col md="4" className="form-group">
                      <label className="form-label-custom">Location ID</label>
                      <FormInput
                        readOnly
                        value={location?.id || ''}
                        style={{backgroundColor: '#f8f9fa', fontFamily: 'monospace'}}
                      />
                      <small className="text-muted">Unique identifier for this location</small>
                    </Col>
                    <Col md="4" className="form-group">
                      <label className="form-label-custom">Client ID</label>
                      <FormInput
                        readOnly
                        value={location?.client || ''}
                        style={{backgroundColor: '#f8f9fa', fontFamily: 'monospace'}}
                      />
                      <small className="text-muted">The client this location belongs to</small>
                    </Col>
                    <Col md="4" className="form-group">
                      <label className="form-label-custom">API Secret</label>
                      <FormInput
                        readOnly
                        value={props.clients?.find(cl => cl?.id === location?.client)?.client_secret || ''}
                        style={{backgroundColor: '#f8f9fa', fontFamily: 'monospace'}}
                      />
                      <small className="text-muted">Authentication secret for API access</small>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row className="mb-2">
          <Col>
            <Card className="p-3 pb-4">
              <CardBody>
                <h5 className="font-weight-bold mb-4">Third-Party Integration Settings</h5>
                <Form>
                  <Row form>
                    <Col md="3" className="text-center">
                      <label className="form-label-custom">Payment Processor</label>
                    </Col>
                    <Col md="9" className="form-group">
                      <FormSelect
                        id="fePaymentProcessor"
                        value={paymentProcessor}
                        disabled={props.user.type !== 'super'}
                        onChange={event => setPaymentProcessor(event.target.value)}
                      >
                        <option value="square">Square</option>
                        <option value="stripe">Stripe</option>
                      </FormSelect>
                      <small className="text-muted">
                        This location processes payments through the selected provider only.
                        {props.user.type !== 'super' && ' Only a super admin can change the processor.'}
                      </small>
                    </Col>
                  </Row>
                  {paymentProcessor === 'square' && (
                    <>
                      <hr />
                      <Row form>
                        <Col md="3" className="text-center">
                          <img
                            className="d-inline-block align-top"
                            src={require("../../images/square.png")}
                            style={{maxWidth: 200, width: "75%"}}
                            alt="Square"
                          />
                        </Col>
                        <Col md="9" className="form-group">
                          <label htmlFor="feSquareLocation" className="form-label-custom">Square</label>
                          {
                            squareLocations?.length > 0 ?
                            <FormSelect id="feSquareLocation" value={squareLocationSelected || ''} onChange={event => setSquareLocationSelected(event.target.value)}>
                              <option value="">Select</option>
                              {squareLocations?.map((squareLocation, idx) => (
                                <option key={idx} value={squareLocation.id}>{squareLocation.name} - {squareLocation.address.address_line_1}</option>
                              ))}
                            </FormSelect> : squareToken && <div style={{height: "12px", width: "100%"}} >No locations found</div>
                          }
                          <div style={{height: "12px", width: "100%"}} />
                          <Button
                            theme="accent"
                            className="mr-1"
                            onClick={async() => {
                              if (locationId) {
                                window.location.href = await generateUrl(locationId);
                              }
                            }}

                          >
                            {squareToken ? 'Reconnect' : 'Connect'}
                          </Button>
                        </Col>
                      </Row>
                    </>
                  )}
                  {paymentProcessor === 'stripe' && (
                    <>
                      <hr />
                      <Row form>
                        <Col md="3" className="text-center d-flex align-items-center justify-content-center">
                          {/* Badge + wordmark stand-in — replace with a real logo asset (require("../../images/stripe.png")) when one is available, matching the T2/Square/SpotHero pattern. */}
                          <div style={{display: 'inline-flex', alignItems: 'center', gap: 10}}>
                            <div style={{
                              width: 40,
                              height: 40,
                              borderRadius: 10,
                              backgroundColor: '#635BFF',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'white',
                              fontWeight: 700,
                              fontSize: 22,
                            }}>S</div>
                            <span style={{fontSize: 26, fontWeight: 600, color: '#32325D'}}>Stripe</span>
                          </div>
                        </Col>
                        <Col md="9" className="form-group">
                          <label className="form-label-custom">Stripe</label>

                          {/* Mutually exclusive by construction — stripeAccountId presence takes
                              priority over the default 'not_connected' status value, since that
                              default can otherwise linger alongside an already-created account
                              (e.g. before the live status fetch resolves, or if Firestore has
                              stripe_account_id set without a mirrored status). */}
                          {stripeAccountStatus === 'active' ? (
                            <div className="alert alert-success" style={{marginBottom: 12}}>
                              This location has its own connected Stripe account (payouts go directly to the operator, minus the JustPark service fee).
                            </div>
                          ) : stripeAccountStatus === 'pending_review' ? (
                            <div className="alert alert-info" style={{marginBottom: 12}}>
                              Everything's submitted — Stripe is reviewing it now. This can take anywhere from a few minutes to a couple of days; there's nothing more to fill in. This page updates on its own once it's approved, but until then, {squareToken ? "citizens will keep paying through the existing Square connection." : "citizens will not be able to pay online here."}
                            </div>
                          ) : stripeAccountId ? (
                            <div className="alert alert-warning" style={{marginBottom: 12}}>
                              Stripe onboarding was started but hasn't been completed yet. Stripe never charges JustPark's platform account for this location — until verification finishes, {squareToken ? "citizens will keep paying through the existing Square connection." : "citizens will not be able to pay online here."}
                            </div>
                          ) : (
                            <div className="alert alert-info" style={{marginBottom: 12}}>
                              Not connected yet. Stripe requires a verified account before it can be used — until then, {squareToken ? "citizens will keep paying through the existing Square connection." : "citizens will not be able to pay online here."}
                            </div>
                          )}

                          {stripeCurrentlyDue?.length > 0 && (
                            <div className="alert alert-warning" style={{marginBottom: 12}}>
                              Stripe still needs: {stripeCurrentlyDue.join(', ')}
                            </div>
                          )}

                          {stripeConnectError && (
                            <div className="alert alert-danger" style={{marginBottom: 12}}>
                              {stripeConnectError}
                            </div>
                          )}

                          {stripeAccountStatus === 'pending_review' ? (
                            <Button
                              theme="outline-secondary"
                              className="mr-1"
                              disabled={stripeStatusChecking}
                              onClick={handleCheckStripeStatus}
                            >
                              {stripeStatusChecking ? 'Checking…' : 'Check status now'}
                            </Button>
                          ) : (
                            // Super admins only — both callables enforce the same rule.
                            props.user.type === 'super' && (
                              stripeAccountId ? (
                                <Button
                                  theme="accent"
                                  className="mr-1"
                                  disabled={stripeConnecting}
                                  onClick={handleConnectStripe}
                                >
                                  {stripeAccountStatus === 'active' ? 'Update Stripe details' : 'Continue onboarding'}
                                </Button>
                              ) : (
                                <div style={{maxWidth: 520}}>
                                  <label htmlFor="feStripeSetupMode" className="form-label-custom">How to set up Stripe</label>
                                  <FormSelect id="feStripeSetupMode" value={stripeSetupMode} onChange={event => setStripeSetupMode(event.target.value)}>
                                    <option value="create">Create a new Stripe account (onboarding form)</option>
                                    <option value="link">Link an existing Stripe account ID</option>
                                  </FormSelect>
                                  {stripeSetupMode === 'create' ? (
                                    <Button
                                      theme="accent"
                                      className="mt-2"
                                      disabled={stripeConnecting}
                                      onClick={handleConnectStripe}
                                    >
                                      Connect Stripe Account
                                    </Button>
                                  ) : (
                                    <>
                                      <div className="d-flex mt-2" style={{gap: 8}}>
                                        <FormInput
                                          placeholder="acct_…"
                                          value={stripeLinkAccountId}
                                          disabled={stripeLinking}
                                          onChange={event => setStripeLinkAccountId(event.target.value)}
                                        />
                                        <Button
                                          theme="accent"
                                          disabled={stripeLinking || !locationId || !/^acct_[A-Za-z0-9]+$/.test(stripeLinkAccountId.trim())}
                                          onClick={handleLinkStripeAccount}
                                        >
                                          {stripeLinking ? 'Linking…' : 'Link'}
                                        </Button>
                                      </div>
                                      <small className="text-muted">
                                        The account must already exist under the JustPark Stripe platform. Its status is read from Stripe when linked.
                                      </small>
                                    </>
                                  )}
                                </div>
                              )
                            )
                          )}

                          {/* Gated to the types createStripeDashboardSession accepts —
                              for anyone else this would be a dead-end redirect. */}
                          {stripeAccountStatus === 'active' && locationId && (props.user.type === 'super' || props.user.type === 'admin') && (
                            <Button
                              theme="outline-secondary"
                              className="mr-1"
                              onClick={() => window.location.href = '/location/' + locationId + '/payments-stripe'}
                            >
                              View payments dashboard
                            </Button>
                          )}

                          {stripeAccountStatus === 'active' && locationId && props.user.type === 'super' && (
                            <div style={{marginTop: 16, maxWidth: 420}}>
                              <span className="text-muted" style={{fontSize: 12}}>
                                {/* OOB-540: this used to be a per-location selector. Refund capability
                                    is now per user, so one admin can refund while a colleague only looks. */}
                                Refunds and dispute responses are granted per user, on the user's own
                                record — not per location. Disputes on Stripe are debited from the
                                platform account, so only grant it where that exposure is acceptable.
                              </span>
                            </div>
                          )}

                          {showStripeOnboarding && stripeConnectInstance && (
                            <div style={{marginTop: 16}}>
                              <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
                                <ConnectAccountOnboarding onExit={handleStripeOnboardingExit} />
                              </ConnectComponentsProvider>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </>
                  )}
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/t2.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="T2"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <label htmlFor="feT2LocationId" className="form-label-custom">T2 Location ID</label>
                      <FormInput
                        id="feT2LocationId"
                        value={t2LocationId || ''}
                        placeholder={'T2 Location ID'}
                        onChange={(event) => setT2LocationId(event.target.value)}
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/spothero.png")}
                        style={{maxWidth: 200, width: "60%"}}
                        alt="Spothero"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <label htmlFor="feSpotheroLocationId" className="form-label-custom">Spothero Location ID</label>
                      <FormInput
                        id="feSpotheroLocationId"
                        value={spotheroLocationId || ''}
                        placeholder={'Spothero Location ID'}
                        onChange={(event) => setSpotheroLocationId(event.target.value)}
                      />
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/parklync.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="Parklync"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParklyncApiKey" className="form-label-custom">Parklync API Key</label>
                          <FormInput
                            id="feParklyncApiKey"
                            value={parklyncApiKey || ''}
                            placeholder={'Parklync API Key'}
                            onChange={(event) => setParklyncApiKey(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParklyncLocationId" className="form-label-custom">Parklync Location ID</label>
                          <FormInput
                            id="feParklyncLocationId"
                            value={parklyncLocationId || ''}
                            placeholder={'Parklync Location ID'}
                            onChange={(event) => setParklyncLocationId(event.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/parkwhiz.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="ParkWhiz"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkWhizLocationId" className="form-label-custom">ParkWhiz Location ID</label>
                          <FormInput
                            id="feParkWhizLocationId"
                            value={parkWhizLocationId || ''}
                            placeholder={'ParkWhiz Location ID'}
                            onChange={(event) => setParkWhizLocationId(event.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row> 
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/parkpliant.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="Parkpliant"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkpliantUsername" className="form-label-custom">Parkpliant Username</label>
                          <FormInput
                            id="feParkpliantUsername"
                            value={parkpliantUsername || ''}
                            placeholder={'Parkpliant Username'}
                            onChange={(event) => setParkpliantUsername(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkpliantPassword" className="form-label-custom">Parkpliant Password</label>
                          <FormInput
                            id="feParkpliantPassword"
                            value={parkpliantPassword || ''}
                            placeholder={'Parkpliant Password'}
                            onChange={(event) => setParkpliantPassword(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkpliantIanaTimezone" className="form-label-custom">Iana Timezone <span style={{textTransform: 'none'}}>(ex. America/New_York)</span></label>
                          <FormInput
                            id="feParkpliantIanaTimezone"
                            value={parkpliantIanaTimezone || ''}
                            placeholder={'Iana Timezone (ex. America/New_York)'}
                            onChange={(event) => setParkpliantIanaTimezone(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkpliantSendDays" className="form-label-custom">Parkpliant sending delay (defaults to 90 days)</label>
                          <FormInput
                            id="feParkpliantSendDays"
                            value={parkpliantSendDays || '90'}
                            placeholder={'Parkpliant sending delay (defaults to 90 days)'}
                            onChange={(event) => setParkpliantSendDays(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkpliantServiceFee" className="form-label-custom">Parkpliant service fee (defaults to $5.00)</label>
                          <FormInput
                            id="feParkpliantServiceFee"
                            type="number"
                            step="0.01"
                            min="0"
                            value={parkpliantServiceFee || '5.00'}
                            placeholder={'Parkpliant service fee (defaults to $5.00)'}
                            onChange={(event) => setParkpliantServiceFee(event.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row> 
                  
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/parkmobile.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="Parkmobile"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkmobileUsername" className="form-label-custom">ParkMobile Username</label>
                          <FormInput
                            id="feParkmobileUsername"
                            value={parkMobileUsername || ''}
                            placeholder={'ParkMobile Username'}
                            onChange={(event) => setParkMobileUsername(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkmobilePassword" className="form-label-custom">ParkMobile Password</label>
                          <FormInput
                            id="feParkmobilePassword"
                            value={parkMobilePassword || ''}
                            placeholder={'ParkMobile Password'}
                            onChange={(event) => setParkMobilePassword(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkmobileApiKey" className="form-label-custom">ParkMobile API Key</label>
                          <FormInput
                            id="feParkmobileApiKey"
                            value={parkMobileApiKey || ''}
                            placeholder={'ParkMobile API Key'}
                            onChange={(event) => setParkMobileApiKey(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkmobileLocationId" className="form-label-custom">ParkMobile Zone ID</label>
                          <FormInput
                            id="feParkmobileLocationId"
                            value={parkMobileLocationId || ''}
                            placeholder={'ParkMobile Zone ID'}
                            onChange={(event) => setParkMobileLocationId(event.target.value)}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center d-flex align-items-center justify-content-center">
                      <span style={{ fontSize: '1.1rem', fontWeight: 700, color: '#3d5170', letterSpacing: '0.05em' }}>PARIS Cloud Permits</span>
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParisCustomerCode" className="form-label-custom">Customer Code</label>
                          <FormInput
                            id="feParisCustomerCode"
                            value={parisCustomerCode || ''}
                            placeholder={'Customer Code'}
                            maxLength={12}
                            onChange={(event) => setParisCustomerCode(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParisUserId" className="form-label-custom">User ID</label>
                          <FormInput
                            id="feParisUserId"
                            value={parisUserId || ''}
                            placeholder={'User ID'}
                            maxLength={50}
                            onChange={(event) => setParisUserId(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParisUserPassword" className="form-label-custom">User Password</label>
                          <FormInput
                            id="feParisUserPassword"
                            value={parisUserPassword || ''}
                            placeholder={'User Password'}
                            maxLength={50}
                            onChange={(event) => setParisUserPassword(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label className="form-label-custom">Facility</label>
                          <div className="d-flex align-items-center" style={{gap: '0.5rem'}}>
                            {parisLocations !== null ? (
                              parisLocations.length > 0 ? (
                                <FormSelect
                                  value={parisFacId || ''}
                                  onChange={(event) => setParisFacId(event.target.value)}
                                  style={{flex: 1}}
                                >
                                  <option value="">Select a facility</option>
                                  {parisFacId && !parisLocations.some((l) => l.facId === parisFacId) && (
                                    <option value={parisFacId}>Current: {parisFacId}</option>
                                  )}
                                  {parisLocations.map((l) => (
                                    <option key={l.facId} value={l.facId}>
                                      {l.locName} ({l.locNumber})
                                    </option>
                                  ))}
                                </FormSelect>
                              ) : (
                                <span style={{flex: 1, fontSize: '0.85rem', color: '#555'}}>No facilities found for these credentials</span>
                              )
                            ) : (
                              parisFacId && <span style={{flex: 1, fontSize: '0.85rem', color: '#555'}}>FacID: {parisFacId}</span>
                            )}
                            <Button
                              type="button"
                              theme="accent"
                              disabled={parisLocationsLoading || !parisCustomerCode?.trim() || !parisUserId?.trim() || !parisUserPassword?.trim()}
                              onClick={async () => {
                                setParisLocationsLoading(true)
                                setParisLocationsError(null)
                                try {
                                  const locs = await props.getParisLocations(parisCustomerCode, parisUserId, parisUserPassword)
                                  setParisLocations(locs)
                                  if (locs.length === 1) setParisFacId(locs[0].facId)
                                } catch (e) {
                                  setParisLocationsError(e.message || 'Failed to load facilities')
                                } finally {
                                  setParisLocationsLoading(false)
                                }
                              }}
                            >
                              {parisLocationsLoading ? 'Loading...' : 'Load Facilities'}
                            </Button>
                          </div>
                          {parisLocationsError && (
                            <small className="text-danger">{parisLocationsError}</small>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/parkchirp.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="ParkChirp"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkchirpEmail" className="form-label-custom">Account Email</label>
                          <FormInput
                            id="feParkchirpEmail"
                            value={parkchirpEmail || ''}
                            placeholder={'Email'}
                            onChange={(event) => setParkchirpEmail(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feParkchirpPassword" className="form-label-custom">Account Password</label>
                          <FormInput
                            id="feParkchirpPassword"
                            type="password"
                            value={parkchirpPassword || ''}
                            placeholder={'Password'}
                            onChange={(event) => setParkchirpPassword(event.target.value)}
                          />
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <FormCheckbox
                            checked={parkchirpStaging || false}
                            onChange={() => { setParkchirpStaging(!parkchirpStaging); setParkchirpFacilities(null) }}
                          >
                            Use staging environment (api.parkcheep.com)
                          </FormCheckbox>
                        </Col>
                      </Row>
                      <Row form>
                        <Col md="12" className="form-group">
                          <label className="form-label-custom">Facility</label>
                          <div className="d-flex align-items-center" style={{gap: '0.5rem'}}>
                            {parkchirpFacilities !== null ? (
                              parkchirpFacilities.length > 0 ? (
                                <FormSelect
                                  value={parkchirpFacilityId || ''}
                                  onChange={(event) => setParkchirpFacilityId(event.target.value)}
                                  style={{flex: 1}}
                                >
                                  <option value="">Select a facility</option>
                                  {parkchirpFacilityId && !parkchirpFacilities.some((f) => f.id === parkchirpFacilityId) && (
                                    <option value={parkchirpFacilityId}>Current: {parkchirpFacilityId}</option>
                                  )}
                                  {parkchirpFacilities.map((f) => (
                                    <option key={f.id} value={f.id}>{f.name} — {f.address}</option>
                                  ))}
                                </FormSelect>
                              ) : (
                                <span style={{flex: 1, minWidth: 0, fontSize: '0.85rem', color: '#555', overflowWrap: 'anywhere'}}>No facilities found for these credentials</span>
                              )
                            ) : (
                              parkchirpFacilityId && <span style={{flex: 1, minWidth: 0, fontSize: '0.85rem', color: '#555', overflowWrap: 'anywhere'}}>ID: {parkchirpFacilityId}</span>
                            )}
                            <Button
                              type="button"
                              theme="accent"
                              style={{flexShrink: 0}}
                              disabled={parkchirpFacilitiesLoading || !parkchirpEmail?.trim() || !parkchirpPassword?.trim()}
                              onClick={async () => {
                                setParkchirpFacilitiesLoading(true)
                                setParkchirpFacilitiesError(null)
                                try {
                                  const facilities = await props.getParkchirpFacilities(parkchirpEmail, parkchirpPassword, parkchirpStaging)
                                  setParkchirpFacilities(facilities)
                                  if (facilities.length === 1) setParkchirpFacilityId(facilities[0].id)
                                } catch (e) {
                                  setParkchirpFacilitiesError(e.message || 'Failed to load facilities')
                                } finally {
                                  setParkchirpFacilitiesLoading(false)
                                }
                              }}
                            >
                              {parkchirpFacilitiesLoading ? 'Loading...' : 'Load Facilities'}
                            </Button>
                          </div>
                          {parkchirpFacilitiesError && (
                            <small className="text-danger">{parkchirpFacilitiesError}</small>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <img
                        className="d-inline-block align-top"
                        src={require("../../images/tezpark.png")}
                        style={{maxWidth: 200, width: "80%"}}
                        alt="TEZPARK"
                      />
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feTezparkLocationId" className="form-label-custom">TEZPARK Location ID</label>
                          <FormInput
                            id="feTezparkLocationId"
                            value={tezparkLocationId || ''}
                            placeholder={'TEZPARK location UUID'}
                            onChange={(event) => setTezparkLocationId(event.target.value)}
                          />
                          <small className="text-muted">The webhook signing secret is configured per client under Client Integrations.</small>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <hr />
                  <Row form>
                    <Col md="3" className="text-center">
                      <h6 className="m-0">JustPark Passes</h6>
                      <small className="text-muted">EventPass / SmartPass</small>
                    </Col>
                    <Col md="9" className="form-group">
                      <Row form>
                        <Col md="12" className="form-group">
                          <label htmlFor="feJustparkPassesLotIds" className="form-label-custom">JustPark Passes Lot IDs</label>
                          <FormTextarea
                            id="feJustparkPassesLotIds"
                            rows="3"
                            value={justparkPassesLotIds || ''}
                            placeholder={'One JustPark lotId (UUID) per line — every lot listed here maps to this location'}
                            onChange={(event) => setJustparkPassesLotIds(event.target.value)}
                          />
                          <small className="text-muted">Set collectLicensePlate = REQUIRED on each JustPark lot: a pass with no plate is held (not enforced) until JustPark sends the plate. The webhook auth secret is configured per client under Client Integrations.</small>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
            <Row className="mt-4">
              <Col>
                <Form>
                  <Row form>
                    <Col md="12" className="form-group text-right">
                      <Button
                        className="mr-2"
                        theme="light"
                        onClick={() => window.location.href='/locations'}
                      >
                        Cancel
                      </Button>
                      <Button
                        theme="accent"
                        onClick={() => {
                          if (location) {
                            updateLocation();
                          }
                        }}
                      >
                        Save Integration Settings
                      </Button>
                    </Col>
                  </Row>                        
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    )
  }

  return (
    <Container fluid className="main-content-container px-0">
      <style>
        {`
          .tooltip-container {
            position: relative;
            display: inline-block;
          }
          
          .tooltip-container:hover .tooltip-content {
            opacity: 1 !important;
            visibility: visible !important;
          }
          
          .tooltip-content {
            position: absolute;
            top: calc(100% + 5px);
            left: 0;
            background-color: white;
            box-shadow: 0 3px 10px rgba(0,0,0,0.1);
            padding: 10px 15px;
            border-radius: 4px;
            width: 250px;
            z-index: 9999;
            font-size: 12px;
            line-height: 1.5;
            border: 1px solid #eaedf3;
            color: #495057;
            opacity: 0;
            visibility: hidden;
            transition: opacity 0.3s, visibility 0.3s;
          }
          
          .tooltip-content::before {
            content: '';
            position: absolute;
            top: -6px;
            left: 10px;
            width: 12px;
            height: 12px;
            background-color: white;
            transform: rotate(45deg);
            border-left: 1px solid #eaedf3;
            border-top: 1px solid #eaedf3;
          }

          /* Improved styling */
          .location-form-container {
            background-color: #fff;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
            margin-bottom: 30px;
          }

          .form-section {
            padding: 1.5rem;
            border-radius: 8px;
            background-color: #fff;
            transition: all 0.2s ease;
          }

          .form-label-custom {
            font-weight: 500;
            color: #3d5170;
            margin-bottom: 0.5rem;
            font-size: 0.875rem;
          }

          .section-title {
            font-size: 1.1rem;
            font-weight: 600;
            color: #3d5170;
            margin-bottom: 1.25rem;
            padding-bottom: 0.75rem;
            border-bottom: 1px solid #eaedf3;
          }

          .form-footer {
            display: flex;
            justify-content: flex-end;
            padding: 1rem 0;
            margin-top: 1.5rem;
            border-top: 1px solid #eaedf3;
          }

          .configurator-sidebar {
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          }

          .configurator-sidebar-header {
            background-color: #f5f6f8;
            padding: 1rem 1.25rem;
            font-weight: 600;
            color: #3d5170;
            border-bottom: 1px solid #eaedf3;
          }

          .configurator-step {
            padding: 1rem 1.25rem;
            border-bottom: 1px solid #eaedf3;
            transition: all 0.2s ease;
          }

          .configurator-step:hover {
            background-color: rgba(33, 170, 115, 0.03);
          }

          .configurator-step.active {
            background-color: rgba(33, 170, 115, 0.08);
          }

          .configurator-step-icon {
            color: #818ea3;
            margin-right: 12px;
            font-size: 1.1rem;
          }

          .configurator-step.completed .configurator-step-icon,
          .configurator-step.completed .configurator-step-title {
            color: #21AA73;
          }

          .configurator-step-title {
            font-weight: 500;
            font-size: 0.9rem;
            color: #5a6169;
          }

          .configurator-step.active .configurator-step-title {
            color: #21AA73;
            font-weight: 600;
          }

          .configurator-step-description {
            color: #818ea3;
            font-size: 0.75rem;
            margin-top: 0.5rem;
            line-height: 1.4;
          }

          .form-input-group {
            margin-bottom: 1.25rem;
          }

          .required-indicator {
            color: #c81712;
            margin-left: 2px;
          }
        `}
      </style>
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        {!props.removeTitles && (
          <Row noGutters className="page-header py-4 mb-3">
            <Col xs="12" sm="8">
              <PageTitle 
                sm="12" 
                title={(locationId ? 'Edit' : 'Add') + ' Location'} 
                subtitle={subtitle}
                className="text-sm-left" 
              />
            </Col>
          </Row>
        )}
        {/* First Row of Posts */}
        <Row>
          <Col className="mb-4" lg={9}>
            <div className="location-form-container">
              {renderConfiguratorStage()}
            </div>
          </Col>
          <Col lg={3}>
            <div className="configurator-sidebar">
              <div className="configurator-sidebar-header">
                Location Setup
              </div>
              <div className={`configurator-step ${configurationStage === 1 ? 'active' : ''} ${configurationStage > 1 || location ? 'completed' : ''}`} 
                onClick={() => configurationStage > 1 || location ? setConfigurationStage(1) : {}}>
                <div className="d-flex align-items-center">
                  <div className="configurator-step-icon">
                    <HomeIcon fontSize="inherit" />
                  </div>
                  <div className="configurator-step-title">
                    Address Details
                  </div>
                  {(configurationStage > 1 || location) && (
                    <div className="ml-auto">
                      <FontAwesomeIcon icon={faCheck} className="text-success" />
                    </div>
                  )}
                </div>
                {configurationStage === 1 && (
                  <div className="configurator-step-description">
                    Enter the address and basic details of the parking location you wish to manage.
                  </div>
                )}
              </div>
              
              <div className={`configurator-step ${configurationStage === 2 ? 'active' : ''} ${configurationStage > 2 || location ? 'completed' : ''}`}
                onClick={() => configurationStage > 2 || location ? setConfigurationStage(2) : {}}>
                <div className="d-flex align-items-center">
                  <div className="configurator-step-icon">
                    <VerifiedUserIcon fontSize="inherit" />
                  </div>
                  <div className="configurator-step-title">
                    Violations
                  </div>
                  {(configurationStage > 2 || location) && (
                    <div className="ml-auto">
                      <FontAwesomeIcon icon={faCheck} className="text-success" />
                    </div>
                  )}
                </div>
                {configurationStage === 2 && (
                  <div className="configurator-step-description">
                    Configure violation rules and payment options for this location.
                  </div>
                )}
              </div>
              
              <div className={`configurator-step ${configurationStage === 3 ? 'active' : ''} ${configurationStage > 3 || location ? 'completed' : ''}`}
                onClick={() => configurationStage > 3 || location ? setConfigurationStage(3) : {}}>
                <div className="d-flex align-items-center">
                  <div className="configurator-step-icon">
                    <AnnouncementIcon fontSize="inherit" />
                  </div>
                  <div className="configurator-step-title">
                    Officer Alerts
                  </div>
                  {(configurationStage > 3 || location) && (
                    <div className="ml-auto">
                      <FontAwesomeIcon icon={faCheck} className="text-success" />
                    </div>
                  )}
                </div>
                {configurationStage === 3 && (
                  <div className="configurator-step-description">
                    Set alert rules for enforcement officers when they scan specific vehicles.
                  </div>
                )}
              </div>
              
              <div className={`configurator-step ${configurationStage === 4 ? 'active' : ''} ${configurationStage > 4 || location ? 'completed' : ''}`}
                onClick={() => configurationStage > 4 || location ? setConfigurationStage(4) : {}}>
                <div className="d-flex align-items-center">
                  <div className="configurator-step-icon">
                    <PrintIcon fontSize="inherit" />
                  </div>
                  <div className="configurator-step-title">
                    Print Settings
                  </div>
                  {(configurationStage > 4 || location) && (
                    <div className="ml-auto">
                      <FontAwesomeIcon icon={faCheck} className="text-success" />
                    </div>
                  )}
                </div>
                {configurationStage === 4 && (
                  <div className="configurator-step-description">
                    Customize how citations will appear when printed.
                  </div>
                )}
              </div>
              
              {location?.id && (
                <div className={`configurator-step ${configurationStage === 5 ? 'active' : ''} ${configurationStage > 5 || location ? 'completed' : ''}`}
                  onClick={() => configurationStage > 5 || location ? setConfigurationStage(5) : {}}>
                  <div className="d-flex align-items-center">
                    <div className="configurator-step-icon">
                      <NoteAddIcon fontSize="inherit" />
                    </div>
                    <div className="configurator-step-title">
                      Integrations
                    </div>
                    {(configurationStage > 5 || location) && (
                      <div className="ml-auto">
                        <FontAwesomeIcon icon={faCheck} className="text-success" />
                      </div>
                    )}
                  </div>
                  {configurationStage === 5 && (
                    <div className="configurator-step-description">
                      Set up third-party integrations and find your API credentials.
                    </div>
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  )
  
}

export default EditLocation;
